<form (submit.prevent)="onSubmit()" class="flex flex-col gap-4">
  <app-parse-request-create-accordion [state]="state()" activeStep="DOCUMENTS">
    <div slot="documents-form" class="flex flex-col gap-6 @container">
      <ui-alert color="primary" [titleOnly]="true">
        <ng-icon slot="icon" name="heroInformationCircle" size="20" class="!block" />
        <h3 slot="title">
          {{ 'cockpit.parseRequests.createDocuments.tip' | transloco }}
        </h3>
      </ui-alert>
      <ui-alert>
        <ng-icon slot="icon" name="heroInformationCircle" size="20" class="!block" />
        <h3 slot="title">
          {{ 'cockpit.parseRequests.createDocuments.alert.title' | transloco }}
        </h3>
        <p>
          {{ 'cockpit.parseRequests.createDocuments.alert.description' | transloco }}
        </p>
      </ui-alert>
      <ui-input-label>
        {{ 'cockpit.parseRequests.createDocuments.uploadLabel' | transloco }}
        <span class="text-error dark:text-error-darkmode">*</span>
        <ui-dropzone slot="input" (dropFiles)="onFileDrop($event)">
          <ng-container slot="title">
            {{ 'cockpit.parseRequests.createDocuments.dropzone.titlePrefix' | transloco }}
            <label
              class="text-primary dark:text-primary-darkmode hover:underline cursor-pointer"
              for="upload-documents-input"
            >
              {{ 'cockpit.parseRequests.createDocuments.dropzone.titleLink' | transloco }}
            </label>
            {{ 'cockpit.parseRequests.createDocuments.dropzone.titleSuffix' | transloco }}
            <input
              type="file"
              class="hidden"
              id="upload-documents-input"
              multiple
              (change)="onFileChange($event)"
            />
          </ng-container>
          <ng-container slot="dragover-title">
            {{ 'cockpit.parseRequests.createDocuments.dropzone.dragoverTitle' | transloco }}
          </ng-container>
          <ng-container slot="subtitle">
            {{ 'cockpit.parseRequests.createDocuments.dropzone.subtitle' | transloco }}
          </ng-container>
          @for (state of outstandingFiles(); track state.id) {
            <ui-dropzone-file
              [error]="state.error"
              [titleText]="state.file.name"
              subtitle="{{ (state.file.size / 1024 / 100) * state.progress | number: '1.2-2' }}/{{
                state.file.size / 1024 | number: '1.2-2'
              }} KB - {{ state.messageKey | transloco: state.messageParams }}"
              [progress]="state.progress"
              [transitionDuration]="300"
              (clickRemove)="onClickFileDelete(state.id)"
              (clickRetry)="onClickRetryFileUpload(state.id)"
            />
          }
          @for (file of uploadedFiles(); track file.id) {
            <ui-dropzone-file
              [progress]="100"
              [titleText]="file.filename"
              [subtitle]="'cockpit.parseRequests.createDocuments.fileStatus.complete' | transloco"
              (clickRemove)="onClickFileDelete(file.id)"
              (clickRetry)="onClickRetryFileUpload(file.id)"
            />
          }
        </ui-dropzone>
      </ui-input-label>

      @if (updateError()) {
        <ui-input-error class="text-end">
          {{ 'cockpit.parseRequests.createDocuments.updateError' | transloco }}
        </ui-input-error>
      }
    </div>

    <div slot="documents-footer" class="@md/documents-footer:flex justify-end gap-2">
      <ui-button
        type="submit"
        expand="full"
        [disabled]="!hasUploadedFiles()"
        [loading]="isUpdateLoading()"
      >
        {{ 'cockpit.parseRequests.createDocuments.nextStep' | transloco }}
        <ng-icon name="heroChevronRight" size="20" class="!block" slot="end" />
      </ui-button>
    </div>
  </app-parse-request-create-accordion>
</form>
